// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickButtonGroup_buttonGroup__an29J {
  --margin: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  margin: calc(-1 * var(--margin));
}
.ClickButtonGroup_buttonGroup__an29J > * {
  margin: var(--margin);
}
.ClickButtonGroup_buttonGroup__an29J.ClickButtonGroup_column__MtDyd {
  flex-direction: row;
}
.ClickButtonGroup_buttonGroup__an29J.ClickButtonGroup_column__MtDyd {
  flex-direction: column;
}
.ClickButtonGroup_buttonGroup__an29J.ClickButtonGroup_alignstart__yYD2d {
  align-items: flex-start;
}
.ClickButtonGroup_buttonGroup__an29J.ClickButtonGroup_alignend__46Pso {
  align-items: flex-end;
}
.ClickButtonGroup_buttonGroup__an29J.ClickButtonGroup_justifystart__zQJr5 {
  justify-content: flex-start;
}
.ClickButtonGroup_buttonGroup__an29J.ClickButtonGroup_justifycenter__S5a01 {
  justify-content: center;
}
.ClickButtonGroup_buttonGroup__an29J.ClickButtonGroup_justifyend__hgsPq {
  justify-content: flex-end;
}
.ClickButtonGroup_buttonGroup__an29J.ClickButtonGroup_justifyspace-around__BvISi {
  width: 100%;
  justify-content: space-around;
}
.ClickButtonGroup_buttonGroup__an29J.ClickButtonGroup_justifyspace-between__PwsEO {
  width: 100%;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/components/ClickButton/ClickButtonGroup.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,gCAAA;AACF;AAAE;EACE,qBAAA;AAEJ;AAAE;EACE,mBAAA;AAEJ;AAAE;EACE,sBAAA;AAEJ;AAAE;EACE,uBAAA;AAEJ;AAAE;EACE,qBAAA;AAEJ;AAAE;EACE,2BAAA;AAEJ;AAAE;EACE,uBAAA;AAEJ;AAAE;EACE,yBAAA;AAEJ;AAAE;EACE,WAAA;EACA,6BAAA;AAEJ;AAAE;EACE,WAAA;EACA,8BAAA;AAEJ","sourcesContent":[".buttonGroup {\n  --margin: 0.5rem;\n  display: flex;\n  flex-wrap: wrap;\n  margin: calc(-1 * var(--margin));\n  & > * {\n    margin: var(--margin);\n  }\n  &.column {\n    flex-direction: row;\n  }\n  &.column {\n    flex-direction: column;\n  }\n  &.alignstart {\n    align-items: flex-start;\n  }\n  &.alignend {\n    align-items: flex-end;\n  }\n  &.justifystart {\n    justify-content: flex-start;\n  }\n  &.justifycenter {\n    justify-content: center;\n  }\n  &.justifyend {\n    justify-content: flex-end;\n  }\n  &.justifyspace-around {\n    width: 100%;\n    justify-content: space-around;\n  }\n  &.justifyspace-between {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonGroup": `ClickButtonGroup_buttonGroup__an29J`,
	"column": `ClickButtonGroup_column__MtDyd`,
	"alignstart": `ClickButtonGroup_alignstart__yYD2d`,
	"alignend": `ClickButtonGroup_alignend__46Pso`,
	"justifystart": `ClickButtonGroup_justifystart__zQJr5`,
	"justifycenter": `ClickButtonGroup_justifycenter__S5a01`,
	"justifyend": `ClickButtonGroup_justifyend__hgsPq`,
	"justifyspace-around": `ClickButtonGroup_justifyspace-around__BvISi`,
	"justifyspace-between": `ClickButtonGroup_justifyspace-between__PwsEO`
};
export default ___CSS_LOADER_EXPORT___;
